import { observer } from 'mobx-react-lite';
import { useCapacityStore } from '../store/CapacityPlannerContext';

const STEPS = [
  'Initializing job...',
  'Fetching forecast data from PLM...',
  'Processing changeover profiles...',
  'Computing headcount requirements...',
  'Aggregating room utilization...',
  'Building dashboard summary...',
  'Finalizing output...',
];

const CPJobOverlay = observer(() => {
  const store = useCapacityStore();
  if (!store.isJobRunning) return null;

  const { jobProgress, jobLog } = store;

  return (
    <div style={{
      position: 'absolute', inset: 0, zIndex: 200,
      background: 'rgba(15, 23, 42, 0.55)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      backdropFilter: 'blur(2px)',
    }}>
      <div style={{
        background: '#fff', borderRadius: '16px',
        padding: '2rem 2.5rem', width: '420px', maxWidth: '90vw',
        boxShadow: '0 20px 60px rgba(0,0,0,0.25)',
      }}>
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1.5rem' }}>
          <span style={{
            width: 36, height: 36, borderRadius: '50%',
            background: '#f3e8ff', display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <i className="pi pi-spin pi-cog" style={{ color: '#7c3aed', fontSize: 18 }} />
          </span>
          <div>
            <div style={{ fontWeight: 700, fontSize: 15, color: '#1e293b' }}>Recalculating Dashboard</div>
            <div style={{ fontSize: 12, color: '#64748b' }}>This usually takes about 7 seconds</div>
          </div>
        </div>

        {/* Progress bar */}
        <div style={{ marginBottom: '1.25rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
            <span style={{ fontSize: 12, color: '#64748b' }}>{store.jobStatusText}</span>
            <span style={{ fontSize: 12, fontWeight: 700, color: '#7c3aed' }}>{jobProgress}%</span>
          </div>
          <div style={{ height: 8, background: '#f1f5f9', borderRadius: 4, overflow: 'hidden' }}>
            <div style={{
              height: '100%', borderRadius: 4,
              background: 'linear-gradient(90deg, #7c3aed, #522d6e)',
              width: `${jobProgress}%`,
              transition: 'width 0.8s ease',
            }} />
          </div>
        </div>

        {/* Step log */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {STEPS.map((step) => {
            const done    = jobLog.includes(step);
            const current = store.jobStatusText === step && !done;
            return (
              <div key={step} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', opacity: done || current ? 1 : 0.35 }}>
                {done
                  ? <i className="pi pi-check-circle" style={{ color: '#10b981', fontSize: 14 }} />
                  : current
                    ? <i className="pi pi-spin pi-spinner" style={{ color: '#7c3aed', fontSize: 14 }} />
                    : <i className="pi pi-circle" style={{ color: '#94a3b8', fontSize: 14 }} />
                }
                <span style={{ fontSize: 12, color: done ? '#10b981' : current ? '#7c3aed' : '#64748b', fontWeight: done || current ? 500 : 400 }}>
                  {step}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
});

export default CPJobOverlay;
